export default "__VITE_ASSET__BUapTPZP__"